// WO-103：注入计时器用于浏览器走查；生产只使用单调时钟。
export type MeetingClock = { now(): number; setTimeout(callback: () => void, delay: number): number; clearTimeout(id: number): void };
export const MEETING_IDLE_MS = 30 * 60 * 1000;
export function startMeetingIdle(clock: MeetingClock, expire: () => void) {
  let lastActivity = clock.now(), timer: number | undefined, stopped = false;
  const schedule = () => {
    timer = clock.setTimeout(() => {
      if (stopped) return;
      const left = MEETING_IDLE_MS - (clock.now() - lastActivity);
      if (left > 0) schedule();
      else { stopped = true; expire(); }
    }, Math.max(0, MEETING_IDLE_MS - (clock.now() - lastActivity)));
  };
  schedule();
  return {
    touch() {
      if (stopped) return;
      if (timer !== undefined) clock.clearTimeout(timer);
      if (clock.now() - lastActivity >= MEETING_IDLE_MS) { stopped = true; expire(); return; }
      lastActivity = clock.now(); schedule();
    },
    stop() { stopped = true; if (timer !== undefined) clock.clearTimeout(timer); }
  };
}
